import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios';
import { mutateClustersConfig } from './mutate-clusters.api';

export const MUTATE_CLUSTERS_REQUEST_CALLED = '@clusters/MUTATE_CLUSTERS_REQUEST_CALLED';

export const MUTATE_CLUSTERS_REQUEST_SUCCEEDED = '@clusters/MUTATE_CLUSTERS_REQUEST_SUCCEEDED';
export const MUTATE_CLUSTERS_REQUEST_FAILED = '@clusters/MUTATE_CLUSTERS_REQUEST_FAILED';
export const MUTATE_CLUSTERS_REQUEST_CANCELED = '@clusters/MUTATE_CLUSTERS_REQUEST_CANCELED';

export const getMutateClustersState = state => state
    . omnichannelBudgetManager.mutateClusters.loadState;

export const mutateClusters = payload => ({
    type: MUTATE_CLUSTERS_REQUEST_CALLED,
    actionTypes: {
        success: MUTATE_CLUSTERS_REQUEST_SUCCEEDED,
        fail: MUTATE_CLUSTERS_REQUEST_FAILED,
        canceled: MUTATE_CLUSTERS_REQUEST_CANCELED,
    },
    config: mutateClustersConfig(payload),
});

const initialState: { loadState: string, error: Error } = {
    loadState: null,
    error: null,
};

export const mutateClustersReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [MUTATE_CLUSTERS_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [MUTATE_CLUSTERS_REQUEST_SUCCEEDED]: state => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [MUTATE_CLUSTERS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [MUTATE_CLUSTERS_REQUEST_CANCELED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
});
